<template>
  <vz-order-disabled-cost v-if="orderStore.costDisabledReason"/>
  <div v-else>
    <div class="text-subtitle color-dark mr-10">
      Итого:
    </div>
    <div
      v-show="isShowPrice"
      class="text-h1 color-dark flex flex-align-items-center flex-wrap"
    >
      <vz-warning-button
        v-if="toastData"
        class="mr-10"
        :toast-data="toastData"
        @mousedown.native.stop
        @mouseup.native.stop
        @touchstart.native.stop
        @touchend.native.stop
      />
      <vz-select
        v-if="hasAnotherCurrency"
        class="mb-0 mr-5 tiny-arrow"
        :modelValue="orderCurrency"
        :items="phones"
        list-class="vz-order-total-price-cost-country-list"
        @change="onChangeCurrency"
        @mousedown.native.stop
        @mouseup.native.stop
        @touchstart.native.stop
        @touchend.native.stop
      />
      <img v-else :src="currencyFlag" class="mr-10" width="16" height="16">
      <span class="flex flex-align-items-center flex-nowrap">{{ totalPrice }} {{ currencyMeasure }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import {PhoneItem, SelectItem, ToastConfigureObject} from '~/types/types';
import {phoneCountries} from '~/common/objects';
import VzSelect from '~/components/ui-kit/vz-select.vue';
import VzOrderDisabledCost from "~/components/personal/order/vz-order-disabled-cost.vue";

const props = defineProps({
  /** Если указан этот параметр, то будет показываться разница в стоимости */
  previousCost: {
    type: Number,
    default: null
  },
  isShowPrice: {
    type: Boolean,
    default: true
  }
})

const orderStore = useOrderStore()

const orderCurrency = computed(() => {
  return orderStore.orderForm.currency || 'RU'
})

const currencyFlag = computed(() => {
  return orderStore.orderPriceCurrency.flag
})

const currencyMeasure = computed(() => {
  return orderStore.orderPriceCurrency.currency
})

const totalPrice = computed(() => {
  if (props.previousCost === null) {
    return orderStore.orderForm.totalPrice?.total || 0
  }
  return (orderStore.orderForm.totalPrice?.total - props.previousCost) || 0
})

const phones = computed((): PhoneItem[] => {
  const items: PhoneItem[] = [phoneCountries.find(p => p.value === 'RU') as PhoneItem]

  if (orderStore.orderForm.totalPrice?.currency?.KZ !== undefined) {
    items.push(phoneCountries.find(p => p.value === 'KZ') as PhoneItem)
  }

  if (orderStore.orderForm.totalPrice?.currency?.BY !== undefined) {
    items.push(phoneCountries.find(p => p.value === 'BY') as PhoneItem)
  }

  if (orderStore.orderForm.totalPrice?.currency?.AM !== undefined) {
    items.push(phoneCountries.find(p => p.value === 'AM') as PhoneItem)
  }

  if (orderStore.orderForm.totalPrice?.currency?.KG !== undefined) {
    items.push(phoneCountries.find(p => p.value === 'KG') as PhoneItem)
  }
  return items
})

const hasAnotherCurrency = computed(() => {
  return phones.value.length > 1 && !useRoute().params.guid
})

const toastData = computed((): ToastConfigureObject[] | false => {
  if (!orderStore.orderWarnings?.length) {
    return false
  }
  return orderStore.orderWarnings.map(warning => ({
    variant: 'error',
    title: warning.title,
    text: warning.message,
    autocloseDelay: 10000
  }))
})

async function onChangeCurrency({value}: SelectItem): Promise<void> {
  orderStore.orderForm.currency = value.toString()
  orderStore.getOrderPriceAction()
}

defineExpose({
  totalPrice,
  currencyMeasure
})
</script>
